// testimonials.js
export const testimonials = [
  {
    id: 1,
    name: "Shriti Pandey",
    location: "Patna",
    image: "/img/team/01.jpg",
    rating: 5,
    review:
      "Bought a new Pureit but dreaded installation drama. RO Care India made it so easy. Came on time, installed perfectly, no mess. Explained maintenance too. Finally found reliable ro service patna. My husband is impressed—that's rare 😊",
  },
  {
    id: 2,
    name: "Mohit Yadav",
    location: "Patna",
    image: "/img/team/02.jpg",
    rating: 5,
    review:
      "This is my 3rd service with them in 2 years. Always on time, always transparent with costs...",
  },
  {
    id: 3,
    name: "Rajesh Kumar",
    location: "Patna",
    image: "/img/team/03.jpg",
    rating: 5,
    review:
      "This is my 3rd service with them in 2 years. Always on time, always transparent with costs...",
  },

];